<template>
  <absolute-visual ref="visual">
    <div class="next-steps-circle" style="width: 60%; height: 60%; left: 20%; top: 20%">
      <div class="subtitle">Next session</div>
      <div class="title">
        <template v-if="sessionNumber == 1">Solo Report</template>
        <template v-if="sessionNumber == 2">Others' views</template>
        <template v-if="sessionNumber == 3">Viewpoints<br />report</template>
        <template v-if="sessionNumber == 4">Engage</template>
        <template v-if="sessionNumber == 5">Develop</template>
      </div>
    </div>
  </absolute-visual>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { TimelineMax } from "gsap";
import AbsoluteVisual from "./absolute-visual.vue";

const props = defineProps<{
  sessionNumber: number;
}>();

const visual = ref<InstanceType<typeof AbsoluteVisual> | null>(null);

const timescale = computed(() => 1);

const fadeIn = (tl: TimelineMax): void => {
  if (!visual.value) {
    return;
  }
  tl.to(visual.value, timescale.value, { autoAlpha: 1 }, 0);
};

defineExpose({
  fadeIn,
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../../styles/sessions/session-variables.less";

.next-steps-circle {
  border: 1px solid @innovator-color;
  border-radius: 50%;
  background-color: rgba(54, 54, 54, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-family: "Libre Franklin", sans-serif;
}

.subtitle {
  color: white;
  font-size: 4vmin;
}

.title {
  color: @innovator-color;
  font-size: 6vmin;
  text-align: center;
}
</style>
